/**
 * Move a treatment within a timeSlot that is inside of a plannedDay
 * @param plannedDay {object} The planned day to modify
 * @param treatment {treatment} The treatment to replace.
 * @return {null|{plannedTimeSlots: *}} The modified planned day, or null if modifying failed.
 */
export function movePlannedDayTreatment(plannedDay, treatment) {
  // Check if plannedDay is defined at all.
  if (!plannedDay) {
    return null;
  }

  // Copy plannedDay
  const _plannedDay = {
    ...plannedDay,
    plannedTimeSlots: plannedDay.plannedTimeSlots.slice(),
  };

  // Get the timeSlot
  const timeSlotIndex = _plannedDay.plannedTimeSlots.findIndex(
    t => t.id === treatment.plannedTimeSlotId,
  );

  if (timeSlotIndex === -1) {
    // No time slot check normal treatments.
    const plannedTreatmentIndex = _plannedDay.plannedTreatments.findIndex(
      t => t.id === treatment.id,
    );

    // Get the index of the treatment
    if (plannedTreatmentIndex === -1) {
      return null;
    }

    // Set the new treatment.
    _plannedDay.plannedTreatments[plannedTreatmentIndex] = treatment;
  }else {

    const timeSlot = _plannedDay.plannedTimeSlots[timeSlotIndex];

    // Get the index of the treatment
    const treatmentIndex = timeSlot.plannedTreatments.findIndex(
      t => t.id === treatment.id,
    );
    if (treatmentIndex === -1) {
      return null;
    }

    // Set the new treatment.
    _plannedDay.plannedTimeSlots[timeSlotIndex].plannedTreatments[
      treatmentIndex
      ] = treatment;
  }
  // Return the modified plannedDay.
  return _plannedDay;
}

/**
 * Remove a treatment from a plannedDay
 * @param plannedDay {object} The planned day to remove the treatment form
 * @param treatment {object} The treatment to remove
 * @return {null|{plannedTimeSlots: *}} the modified plannedDay, or null if modifying failed.
 */
export function deletePlannedDayTreatment(plannedDay, treatment) {
  // Check if plannedDay is defined at all.
  if (!plannedDay) {
    return null;
  }

  // Copy plannedDay
  const _plannedDay = {
    ...plannedDay,
    plannedTimeSlots: plannedDay.plannedTimeSlots.slice(),
  };

  // Get the list to remove the treatment from
  let list = _plannedDay.plannedTimeSlots;
  // get list of the plannedTreatments not in a timeSlot
  const listTreatments = _plannedDay.plannedTreatments;

  if (treatment.plannedTimeSlotId === null) {
    // Get index of the treatment
    const index = listTreatments.findIndex(t => t.id === treatment.id);
    // remove it from the list of plannedTreatments
    listTreatments.splice(index, 1);
  } else {
    const timeSlot = _plannedDay.plannedTimeSlots.find(
      t => t.id === treatment.plannedTimeSlotId,
    );
    if (!timeSlot) {
      return null;
    }
    list = timeSlot.plannedTreatments;

    // Get the index of the treatment.
    const index = list.findIndex(t => t.id === treatment.id);
    if (index === -1) {
      return null;
    }

    // Remove it and return teh modified plannedDay.
    list.splice(index, 1);
  }
  return _plannedDay;
}
